const handler = ( $ ) => {

	$( document ).ready( function () {
		if ( typeof URL !== 'function' ) {
			return;
		}

		const url = new URL( window.location.href );

		if ( url.searchParams.has( 'utm_campaign' ) ) {
			$.cookie( 'utm_campaign', url.searchParams.get( 'utm_campaign' ), {
				path: '/',
			} );
		}

		if ( url.searchParams.has( 'utm_medium' ) ) {
			$.cookie( 'utm_medium', url.searchParams.get( 'utm_medium' ), {
				path: '/',
			} );
		}

		if ( url.searchParams.has( 'utm_source' ) ) {
			$.cookie( 'utm_source', url.searchParams.get( 'utm_source' ), {
				path: '/',
			} );
		}

		if ( $( 'input#input_4_9' ).length ) {
			$( 'input#input_4_9' ).each( function () {
				$( this ).val( $.cookie( 'utm_campaign' ) );
			} );
		}

		if ( $( 'input#input_4_10' ).length ) {
			$( 'input#input_4_10' ).each( function () {
				$( this ).val( $.cookie( 'utm_medium' ) );
			} );
		}

		if ( $( 'input#input_4_11' ).length ) {
			$( 'input#input_4_11' ).each( function () {
				$( this ).val( $.cookie( 'utm_source' ) );
			} );
		}
	});

};

export default ( ( $ ) => $( handler ) )( jQuery );
